import React from 'react';
import { useSelectTab } from '../../TabLayout/hooks/useSelectTab';
import { useTabListItem } from '../hooks/useTabListItem';

type TabListItemContainerProps = { children: React.ReactNode };

const TabListItemContainer = ({ children }: TabListItemContainerProps) => {
	const { defaultActiveTab, blockClass, label, tabId } = useTabListItem();
	const { selectedTab, setSelectedTab } = useSelectTab();

	const isActive = (): string => {
		const className = `listItemActive vtex-tab-layout-0-x-listItemActive ${blockClass ? `listItemActive--${blockClass} vtex-tab-layout-0-x-listItemActive--${blockClass}` : ''}`;
		if (selectedTab) {
			if (selectedTab == tabId) {
				return className;
			}
			return '';
		} else if (defaultActiveTab) {
			return className;
		}
		return '';
	};

	return (
		<div
			onClick={() => setSelectedTab(tabId)}
			className={`listItem listItem--${blockClass} vtex-tab-layout-0-x-listItem vtex-tab-layout-0-x-listItem--${blockClass} ${isActive()} ph2 pv2 ma2`}
		>
			<button
				className="vtex-button bw1 ba fw5 v-mid relative pa0 lh-solid br2 min-h-regular t-action bg-action-primary b--action-primary c-on-action-primary hover-bg-action-primary hover-b--action-primary hover-c-on-action-primary pointer "
				type="button"
			>
				<div
					className="vtex-button__label flex items-center justify-center h-100 ph6 "
					style={{ paddingTop: '.25em', paddingBottom: '.32em' }}
				>
					{label}
				</div>
			</button>
		</div>
	);
};

export default TabListItemContainer;
